import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import heroBg from '@/assets/Bg2.png';

interface Props {
    children: ReactNode;
    className?: string;
}

export default function MainHero({ children, className }: Props) {
    return (
        <div
            className={cn(
                'relative z-0 flex w-full justify-start overflow-hidden pt-[160px]',
                'min-h-[560px] sm:min-h-[620px] lg:min-h-[670px]',
                className,
            )}
        >
            {/* Viewport-width layer keeps the bg stable when zooming out */}
            <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
                <img
                    src={heroBg}
                    alt=""
                    className="absolute left-1/2 top-0 h-full min-h-full w-[100vw] min-w-full max-w-none -translate-x-1/2 object-cover object-top"
                />
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="relative z-10 w-full mainContainer pb-16"
            >
                {children}
            </motion.div>
        </div>
    );
}
